import type { HeroSlide, HeroSlideInput } from '@shop-monorepo/types';
import { useMutation, useQuery } from '@tanstack/react-query';
import { message } from 'antd';

import { apiClient } from '../services/api';

const HERO_SLIDE_QUERY_KEY = ['hero-slides'];

export const useHeroSlides = () => {
  return useQuery<HeroSlide[], Error>({
    queryKey: HERO_SLIDE_QUERY_KEY,
    queryFn: () => apiClient.heroSlides.all(),
  });
};

export const useCreateHeroSlide = () => {
  return useMutation<HeroSlide, Error, HeroSlideInput>({
    mutationFn: (input) => apiClient.heroSlides.create(input),
    meta: { invalidates: [HERO_SLIDE_QUERY_KEY] },
    onSuccess: () => {
      message.success('Слайд успішно додано!');
    },
    onError: (error) => {
      message.error(`Не вдалося додати слайд: ${error.message}`);
    },
  });
};

export const useUpdateHeroSlide = () => {
  return useMutation<HeroSlide, Error, { id: number; slide: HeroSlideInput }>({
    mutationFn: ({ id, slide }) => apiClient.heroSlides.update(id, slide),
    meta: { invalidates: [HERO_SLIDE_QUERY_KEY] },
    onSuccess: () => {
      message.success('Слайд успішно оновлено!');
    },
    onError: (error) => {
      message.error(`Не вдалося оновити слайд: ${error.message}`);
    },
  });
};

export const useDeleteHeroSlide = () => {
  return useMutation<{ message: string }, Error, number>({
    mutationFn: (id) => apiClient.heroSlides.delete(id),
    meta: { invalidates: [HERO_SLIDE_QUERY_KEY] },
    onSuccess: () => {
      message.success('Слайд успішно видалено!');
    },
    onError: (error) => {
      message.error(`Не вдалося видалити слайд: ${error.message}`);
    },
  });
};
